import { validateOrigin } from '../../utils/message';
import { EMessageResponseTypes } from '../../index';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getReadyHandler(resolve, reject) {
  return function (event) {
    if (!validateOrigin(event.origin)) {
      return;
    }
    if (event.data) {
      var messageResponse;
      try {
        messageResponse = JSON.parse(event.data);
      } catch (e) {
        return;
      }
      if (messageResponse.type === EMessageResponseTypes.workerRegistred) {
        if (messageResponse.value) {
          resolve();
        } else {
          reject('Service worker was not registered');
        }
      }
    }
  };
}